import { CSSProperties } from 'react';
import { css } from '@emotion/css';

// Common styles
export const loaderStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,
};

export const baseEstimateButtonStyle: CSSProperties = {
  width: '100%',
  height: '50px',
  border: '1px solid #000000ff',
  // border: '1px solid #ee8865',
  padding: '2px',
  fontWeight: 300,
  fontSize: '16px',
  lineHeight: '22px',
  fontFamily: 'Open Sans, sans-serif',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  letterSpacing: '0.03em',
  margin: '5px 0',
  cursor: 'pointer',
  transition: 'opacity 0.3s',
  borderRadius: '8px',
  background: '#000000ff',
  // background: '#EE8865',
  color: '#FFFFFF',
};

export const basePlansListStyle: CSSProperties = {
  flex: 1,
  overflowY: 'auto',
};

// Desktop specific styles
export const desktopContainerStyle: CSSProperties = {
  height: 'calc(100dvh - 65px)',
  width: '100vw',
  textAlign: 'left',
};

export const desktopMapContainerStyle: CSSProperties = {
  height: '100%',
};

export const desktopSidebarStyle: CSSProperties = {
  height: '100%',
  transition: 'height 0.5s opacity',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
};

export const desktopEstimateButtonStyle: CSSProperties = {
  ...baseEstimateButtonStyle,
  top: '0.25em',
};

// Mobile specific styles
export const mobileContainerStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const mobileMapContainerStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1,
};

export const mobileControlsContainerStyle: CSSProperties = {
  position: 'absolute',
  bottom: '65px', // Space for bottom navigation
  left: 0,
  width: '100%',
  zIndex: 2,
  padding: '0 8px',
};

export const mobilePlansButtonStyle: CSSProperties = {
  ...baseEstimateButtonStyle,
};

export const mobilePlansListStyle: CSSProperties = {
  ...basePlansListStyle,
  WebkitOverflowScrolling: 'touch',
  paddingBottom: '20px',
  height: 'auto',
  overflowX: 'hidden',
  flex: 1,
};

export const mobileGeocoderClass = css`
  position: absolute;
  width: calc(100% - 16px);
  top: 8px;
  left: 8px;
  text-align: left;
  z-index: 3;

  .mapboxgl-ctrl-geocoder {
    border-radius: 8px;
  }
`;
